import React from 'react'
import GettingStartedPage from '../../components/Merchant/MerchantOnboarding/GettingStarted';

const GettingStarted = () => {
  return (
    <GettingStartedPage />
  )
}

export default GettingStarted;